import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import AgTable from '../../../Components/Table/AgTable';

function EvolucionVentasDesgloseMes({ unidadEconomicaId, mesCierre, anio }) {
    let headers = [
        {
            headerName: 'CeBe',
            field: 'centroBeneficio',
        },
        {
            headerName: 'Semana 1',
            field: 'semana1',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.semana1, true)}</>
            )
        },
        {
            headerName: 'Semana 2',
            field: 'semana2',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.semana2, true)}</>
            )
        },
        {
            headerName: 'Semana 3',
            field: 'semana3',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.semana3, true)}</>
            )
        },
        {
            headerName: 'Semana 4',
            field: 'semana4',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.semana4, true)}</>
            )
        },
        {
            headerName: 'Semana 5',
            field: 'semana5',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.semana5, true)}</>
            )
        },
        {
            headerName: 'Total General',
            field: 'totalGeneral',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.totalGeneral, true)}</>
            )
        }
    ];

    return (
        <AgTable
            idContent={"EvolucionVentasDesgloseMes " + unidadEconomicaId + mesCierre + anio}
            apiService={Api.EvolucionVentasDesgloseMes}
            setAuxData={null}
            header={headers}
            titleExcel={"Evolucion Ventas Desglose Mes - " + mesCierre + unidadEconomicaId + + " " + anio}
            conditions={true}
            args={{
                unidadEconomicaId: unidadEconomicaId,
                mesCorte: mesCierre,
                anio: (anio + 1),
                token: useGetToken()
            }}
            hideFilter={false}
            paginationPageSize={8}
            rowHeight={40}
            useFlex={false}
        />
    )
}

export default EvolucionVentasDesgloseMes
